var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAwardBonusIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 44,
    viewBox: "0 0 60 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.19622 3.54003C-7.41044 13.9499 4.52873 28.3413 12.1992 34.2358C22.9611 42.506 47.848 50.4217 58.1951 34.2358C69.6869 16.2591 23.2045 -9.47229 6.19622 3.54003Z",
    fill: "#F4F5F7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5999 34.976C24.5999 35.1985 24.7813 35.3798 25.0041 35.3798H27.0251V34.5723H24.5999V34.976Z",
    fill: "#F1BD6C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5999 32.957H27.0251V33.7645H24.5999V32.957Z",
    fill: "#F1BD6C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5999 29.7266H27.0251V30.5341H24.5999V29.7266Z",
    fill: "#F1BD6C"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M22.175 31.3423H23.7919V26.901C23.7919 26.2332 24.3359 25.6897 25.0045 25.6897H27.8339V20.0371H22.175V31.3423Z",
    fill: "#83A9FF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5999 31.3418H27.0251V32.1493H24.5999V31.3418Z",
    fill: "#F1BD6C"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M28.6418 20.0371H31.0671V25.6897H28.6418V20.0371Z",
    fill: "#83A9FF"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M28.9767 16.8072L25.026 12.2031L23.1719 14.6725L26.7337 16.8072H28.9767Z",
    fill: "#83A9FF"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M36.5379 14.6725L34.6838 12.2031L30.7332 16.8072H32.9761L36.5379 14.6725Z",
    fill: "#83A9FF"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5593 17.6133H39.1508V19.2283H20.5593V17.6133Z",
    fill: "#83A9FF"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5999 28.1113H27.0251V28.9188H24.5999V28.1113Z",
    fill: "#F1BD6C"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M31.875 20.0371H37.5339V25.6897H31.875V20.0371Z",
    fill: "#83A9FF"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M43.5955 26.4961H41.5745V27.3036H43.9997V26.8999C43.9997 26.6774 43.8182 26.4961 43.5955 26.4961Z",
    fill: "#F1BD6C"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M41.5745 28.1113H43.9997V28.9188H41.5745V28.1113Z",
    fill: "#F1BD6C"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M41.5745 31.3418H43.9997V32.1493H41.5745V31.3418Z",
    fill: "#F1BD6C"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M41.5745 35.3798H43.5955C43.8182 35.3798 43.9997 35.1985 43.9997 34.976V34.5723H41.5745V35.3798Z",
    fill: "#F1BD6C"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M41.5745 29.7266H43.9997V30.5341H41.5745V29.7266Z",
    fill: "#F1BD6C"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M41.5745 32.957H43.9997V33.7645H41.5745V32.957Z",
    fill: "#FFBB5A"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M27.8333 35.3788H40.7665V26.4961H27.8333V35.3788ZM34.2999 27.3036C36.3053 27.3036 37.9373 28.934 37.9373 30.9374C37.9373 32.9409 36.3053 34.5712 34.2999 34.5712C32.2944 34.5712 30.6624 32.9409 30.6624 30.9374C30.6624 28.934 32.2944 27.3036 34.2999 27.3036Z",
    fill: "#F1BD6C"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M33.8959 33.7306V32.9554H33.0875V32.1479H34.3001C34.5229 32.1479 34.7043 31.9666 34.7043 31.7441C34.7043 31.5216 34.5229 31.3403 34.3001 31.3403C33.6316 31.3403 33.0875 30.7969 33.0875 30.1291C33.0875 29.6034 33.4266 29.1592 33.8959 28.9921V28.1426C32.5269 28.3396 31.4707 29.5158 31.4707 30.9366C31.4707 32.3574 32.5269 33.5335 33.8959 33.7306Z",
    fill: "#FFBB5A"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M34.3002 30.5328C34.9688 30.5328 35.5128 31.0763 35.5128 31.7441C35.5128 32.2698 35.1737 32.7139 34.7044 32.8811V33.7306C36.0734 33.5335 37.1296 32.3574 37.1296 30.9366C37.1296 29.5158 36.0734 28.3396 34.7044 28.1426V28.9178H35.5128V29.7253H34.3002C34.0775 29.7253 33.896 29.9066 33.896 30.1291C33.896 30.3515 34.0775 30.5328 34.3002 30.5328Z",
    fill: "#FFBB5A"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M27.0251 26.4961H25.0041C24.7813 26.4961 24.5999 26.6774 24.5999 26.8999V27.3036H27.0251V26.4961Z",
    fill: "#F1BD6C"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M36.2336 8.69919L35.1445 8.34712C34.7852 7.35611 36.3851 6.99883 36.0259 6L37.1149 6.35207C37.4742 7.3509 35.8743 7.70818 36.2336 8.69919Z",
    fill: "#FCDF98"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M24.2712 8.7284L23.7132 9.66465C22.6494 9.81454 22.5865 8.28084 21.5179 8.42583L22.0729 7.49047C23.1415 7.34549 23.2044 8.87919 24.2712 8.7284Z",
    fill: "#84C8B1"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M41.5057 22.2848L40.662 21.5948C40.6706 20.5205 42.1968 20.6844 42.211 19.6062L43.0543 20.293C43.0401 21.3713 41.5139 21.2074 41.5057 22.2848Z",
    fill: "#84C8B1"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5876 20.8159L15.3031 19.8684C15.8322 19.0121 16.8743 19.858 17.4094 19.0012L17.6951 19.9461C17.16 20.8029 16.1179 19.957 15.5876 20.8159Z",
    fill: "#F4AE72"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAwardBonusIcon);
export default __webpack_public_path__ + "static/media/award-bonus-icon.9841055a136c5ed6d1ed2b3cbae0d7eb.svg";
export { ForwardRef as ReactComponent };